import { GET_FRAIS_PORT } from '../../domain/commande/getFraisPort';
import { PanierState, RemoveLineTypes } from '../../types/panier/panier.def';
import { sanitizeCalul } from '../number/sanitizeCalul';

export const removeLineParams = (
  panier: PanierState,
  variables: RemoveLineTypes
): PanierState => {
  const lineToRemove = variables.lineToRemove;
  const commandeLines = [...panier.commandeLines];

  if (commandeLines.length < lineToRemove) return;
  commandeLines.splice(lineToRemove, 1);

  const newPanier: PanierState = {
    ...panier,
    fraisPort: {
      montant: GET_FRAIS_PORT(
        sanitizeCalul(panier.totalPanier - variables.totalLine),
        panier.fraisPort.applicable
      ),
      applicable: panier.fraisPort.applicable
    },
    totalPanier: sanitizeCalul(panier.totalPanier - variables.totalLine),
    commandeLines
  };
  return newPanier;
};
